export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13563.1cc44e38.jpg";